import { X } from "lucide-react";

const SORT_LABELS = { salary: "Melhor pagas", distance: "Mais perto" };

function daysLabel(d) {
  if (String(d) === "1") return "Últimas 24h";
  return `Últimos ${d} dias`;
}

/**
 * Etiquetas dos filtros ativos, cada uma com X para remover.
 *
 * Props:
 *  - params: URLSearchParams
 *  - onRemove: (keys: string[]) => void — remove todas as chaves indicadas de uma vez
 *  - onClearAll: () => void
 *  - hide?: string[] — chaves que não devem aparecer (ex.: localização fixa da página)
 */
export function ActiveFilterTags({ params, onRemove, onClearAll, hide = [] }) {
  const get = (k) => (hide.includes(k) ? "" : params.get(k) || "");
  const tags = [];
  const nearConcelho = get("near_concelho");
  const nearDistrict = params.get("near_district") || "";

  if (get("q")) tags.push({ id: "q", label: `"${get("q")}"`, group: "Pesquisa", keys: ["q"] });
  if (nearConcelho) {
    tags.push({ id: "near", group: "Distância", label: `Até ${params.get("radius_km") || 25} km de ${nearConcelho}`,
      keys: ["near_district", "near_concelho", "radius_km", ...(params.get("sort") === "distance" ? ["sort"] : [])] });
  }
  if (get("district")) {
    tags.push({ id: "district", group: "Distrito", label: get("district"),
      keys: ["district", "concelho", ...(nearDistrict === get("district") && !nearConcelho ? ["near_district"] : [])] });
  } else if (nearDistrict && !nearConcelho && !hide.includes("near_district")) {
    tags.push({ id: "near_district", group: "Distrito", label: nearDistrict, keys: ["near_district"] });
  }
  if (get("concelho")) tags.push({ id: "concelho", group: "Concelho", label: get("concelho"), keys: ["concelho"] });
  if (get("category")) tags.push({ id: "category", group: "Setor", label: get("category"), keys: ["category"] });
  if (get("regime")) tags.push({ id: "regime", group: "Regime", label: get("regime"), keys: ["regime"] });
  if (get("work_mode")) tags.push({ id: "work_mode", group: "Modalidade", label: get("work_mode"), keys: ["work_mode"] });
  if (get("days")) tags.push({ id: "days", group: "Publicado", label: daysLabel(get("days")), keys: ["days"] });
  if (get("featured")) tags.push({ id: "featured", group: "", label: "Em destaque", keys: ["featured"] });
  if (get("has_cover")) tags.push({ id: "has_cover", group: "", label: "Com foto", keys: ["has_cover"] });
  if (get("sort") && SORT_LABELS[get("sort")] && !(get("sort") === "distance" && nearConcelho)) {
    tags.push({ id: "sort", group: "Ordenar", label: SORT_LABELS[get("sort")], keys: ["sort"] });
  }

  if (!tags.length) return null;

  return (
    <div data-testid="active-filter-tags" className="flex flex-wrap items-center gap-2">
      <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-slate-400 mr-1">Filtros ativos</span>
      {tags.map((t) => (
        <span key={t.id} data-testid={`active-tag-${t.id}`}
          className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 text-white pl-3 pr-1 py-1 text-xs font-medium shadow-sm">
          {t.group && <span className="text-slate-400">{t.group}:</span>}
          <span>{t.label}</span>
          <button type="button" data-testid={`remove-tag-${t.id}`} aria-label={`Remover filtro ${t.label}`}
            onClick={() => onRemove(t.keys)}
            className="ml-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full hover:bg-white/20 transition-colors">
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      {tags.length > 1 && onClearAll && (
        <button type="button" data-testid="remove-all-tags" onClick={onClearAll}
          className="text-xs font-semibold text-slate-500 hover:text-slate-900 underline-offset-2 hover:underline ml-1">
          Limpar todos
        </button>
      )}
    </div>
  );
}

export default ActiveFilterTags;
